import React from 'react'
import { Button, Icon } from 'semantic-ui-react'
import { Trans } from 'react-i18next'
import buttonStyles from './styles'

const BackButton = props => {
  const { ...rest } = props

  return (
    <Button color='grey' inverted type='button' style={{ ...buttonStyles.bottomButtonStyle, width: '11.063rem' }} {...rest}>
      <Icon name='chevron left' color='blue' />
      <Trans i18nKey='button.back' />
    </Button>
  )
}

export default BackButton
